window.redshift = require('./module.js');


/*****************
 ** WEBPACK FOOTER
 ** ./src/load/global.js
 ** module id = 0
 ** module chunks = 0
 **/